jQuery(function($) {
  // ページを表示
  $('body').removeClass('page-hide');

  // 初期ズーム用ターゲット
  $('.image_scale_down').addClass('is-zoomed');

  // スクロール・リサイズ時の処理
  function isInViewport($el) {
    const rect = $el[0].getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function onScrollOrResize() {
    $('.image_scale_down').each(function() {
      const $el = $(this);
      if (!$el.hasClass('is-right') && isInViewport($el)) {
        $el.removeClass('is-zoomed').addClass('is-right');
      }
    });

    $('.image_slide_right').each(function() {
      const $el = $(this);
      if (!$el.hasClass('is-slide-right') && isInViewport($el)) {
        setTimeout(function() {
          $el.addClass('is-slide-right');
        }, 300);
      }
    });
    
    $('.image_slide_left').each(function() {
      const $el = $(this);
      if (!$el.hasClass('is-slide-left') && isInViewport($el)) {
        setTimeout(function() {
          $el.addClass('is-slide-left');
        }, 300);
      }
    });

    $('.image_zoomout_left').each(function() {
      const $el = $(this);
      if (!$el.hasClass('is-zoomout-left') && isInViewport($el)) {
        setTimeout(function() {
          $el.addClass('is-zoomout-left');
        }, 300);
      }
    });

    $('.image_zoomout_right').each(function() {
      const $el = $(this);
      if (!$el.hasClass('is-zoomout-right') && isInViewport($el)) {
        setTimeout(function() {
          $el.addClass('is-zoomout-right');
        }, 300);
      }
    });

    $('.image_zoomout_center').each(function() {
      const $el = $(this);
      if (!$el.hasClass('is-zoomout-center') && isInViewport($el)) {
        setTimeout(function() {
          $el.addClass('is-zoomout-center');
        }, 300);
      }
    });
  }

  // イベント登録＆初回実行
  $(window).on('scroll resize', onScrollOrResize);
  onScrollOrResize();
  
  if ($('body').hasClass('template-page-about_nuna')) {
    const $sections = $('.shopify-section');

    if ($sections.length >= 16) {
      $sections.eq(15).addClass('about_design_sec'); // 16個目（0始まり）
    }

    if ($sections.length >= 18) {
      $sections.eq(17).addClass('designed_around_sec'); // 18個目（0始まり）
    }
  }
  
  // 監視対象の要素を取得
  var $toggle = $('.mobile-toggle-wrapper');
  if (!$toggle.length) return;

  // MutationObserver のコールバック
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        var isActive = $toggle.hasClass('active');
        $('.header-section').toggleClass('nav-open', isActive);
      }
    });
  });

  // オブザーバーを設定（class 属性のみ監視）
  observer.observe($toggle.get(0), {
    attributes: true,
    attributeFilter: ['class']
  });

  // テーマの他コードで不要になったら停止も可能
  // observer.disconnect();
});